import { render, staticRenderFns } from "./Slot.vue?vue&type=template&id=46e5c03e&lang=pug&"
import script from "./Slot.vue?vue&type=script&lang=js&"
export * from "./Slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46e5c03e', component.options)
    } else {
      api.reload('46e5c03e', component.options)
    }
    module.hot.accept("./Slot.vue?vue&type=template&id=46e5c03e&lang=pug&", function () {
      api.rerender('46e5c03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview_area/built-in component/Slot.vue"
export default component.exports